import { env } from './env';
import { isProd, isDev, isStaging } from './utils';
export default env;
export { isProd, isDev, isStaging };
